<template>
  <div class="card md:pr-6">
    <SpeakolChoroplethMap
      :width="width"
      :height="height"
      :geoInsights="geoInsights"
      :filters="filters"
      ref="map">
        <template v-slot:empty-country-tooltip>
          <slot name="empty-country-tooltip"></slot>
        </template>
    </SpeakolChoroplethMap>
  </div>

</template>

<script>
export default {
  props: {
    width: {
      type: Number
    },
    height : {
      type: Number,
      default: 450
    },
    filters: {
      type: Array
    },
    geoInsights: {
      type: Array
    }
  },

  methods: {

    disableAllFiltersExcept (filterValue) {
      this.filters.filter(filterItem => filterItem.value !== filterValue).forEach((filterItem) => {
        this.$refs[filterItem.value][0].disable()
      })
    },

    updateMap (filterValue) {
      this.$refs['map'].setSelectedFilter(filterValue)
    },

    clearMap () {
      this.$refs['map'].clearFilters()
    }


  }

}
</script>


<style lang="scss" scoped>
.card {
  background-color: #fff;
  padding: 0 !important;
}

.title {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.description {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.1px;
  color: rgba(44, 44, 44, 0.7);
}

</style>
